export default __webpack_public_path__ + "static/media/ci-back-ejemplo.f516a4d4.jpg";